query allFootballTeams(
  $first: Int,
  $offset: Int,
  $filter: FootballTeamFilter,
  ) {
  teams: allFootballTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
        squad
        shortName
        name
        source
        teamId
        division
        stadium
        city
        state
        mappings: footballTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingType
        }
      }
    }
    totalCount
  }
}
